const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

/**
 * Turns a stored upload path into something an `<img>` can actually load.
 *
 * The API stores and returns uploads as relative paths (`/uploads/ban_x.jpg`),
 * which is correct — writing the absolute URL into the database would break the
 * moment the API moves host. But rendering one raw resolves it against whatever
 * origin the page is on, so on the admin at localhost:3000 or on
 * www.nso-india.com it 404s and the image silently never appears.
 *
 * This lived inside bannerApi and banners were the only caller. Gift-card
 * artwork hit the identical bug the day admin uploads shipped, so it lives on
 * its own now — one implementation, and the next feature that accepts an upload
 * does not get to rediscover this.
 *
 * Already-absolute values (http, data:, blob: for a local preview) pass through.
 */
export const resolveUpload = (url) => {
  if (!url || typeof url !== 'string') return '';
  if (/^(https?:|data:|blob:)/.test(url)) return url;
  return `${BACKEND_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

export default resolveUpload;
